import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthToken } from "../../services/auth-service";
import httpService from "../../services/http-service";
import { Table1 } from "../Administration/Table1/Table1";
import { setDynamicTab } from "../../reducer/HomePageReducer";
import { useDispatch } from "react-redux";
import AdminCrumbs from "../Administration/components/AdminCrumbs";
import { DynamicTabb } from "../../components/DynamicTab/DynamicTab";
import { groupsColumn1 } from './Data'
import { logOut } from "../../components/Logout";
import AddGroupPopup from "./AddGroupPopup";



const UserGroups = () => {
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const [error, setError] = useState(false);
  const [exportPopupOpen, setexportPopupOpen] = useState(false);
  const [editGroupData, setEditGroupData] = useState(null);
  const title = "User Groups";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let domainName = (url) => url.match(/(?:http(?:s)?:\/\/)?(?:w{3}\.)?([^.]+)/i)[1];
  let pathURL = domainName(window.location.href);
  const token = getAuthToken();
  const [addPopupVisible, setAddPopupVisible] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    message: "",
    type: "",
  });

  const handleEditGroup = (row) => {
    setEditGroupData(row);
    setAddPopupVisible(true);
  };


  const setGroupTableData = (data) => {
    return data.map((val, i) => ({
      "Group Name": val.groupName,
      gGroupId: val.groupId,
      ID: i,
      editGroup: handleEditGroup,
    }));
  };

  const AllGroupList = async () => {
    await httpService
      .get(`api/user/get-all-groups`, {
        headers: { Authorization: `Bearer ${token}`, Domain: `${pathURL}` },
      })
      .then((val) => {
        setData(setGroupTableData(val?.data.data));
        console.log("set group data", val)
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };


  useEffect(() => {
    AllGroupList();
  }, []);

  return (
    <>
      <AddGroupPopup
        visible={addPopupVisible}
        onClose={() => {
          setAddPopupVisible(false);
          setEditGroupData(null);      
        }}
        onSuccess={AllGroupList}
        toastConfig={toastConfig}
        setToastConfig={setToastConfig}
        groupToEdit={editGroupData}
      />
      <AdminCrumbs title={title} user={"User"} />
      <div className="admin_userlist">
        <DynamicTabb />
        <div className="admin_userlist_content">
          <div className="utf">
            <p className="utf_heading">US.10</p>
          </div>
          <div className="buttons">
            <button
              className="btn"
              onClick={() => {
                setEditGroupData(null);
                setAddPopupVisible(true);
              }}
            >
              Add New
              <svg
                className="svg-blue-dark"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14 11H11V14C11 14.55 10.55 15 10 15C9.45 15 9 14.55 9 14V11H6C5.45 11 5 10.55 5 10C5 9.45 5.45 9 6 9H9V6C9 5.45 9.45 5 10 5C10.55 5 11 5.45 11 6V9H14C14.55 9 15 9.45 15 10C15 10.55 14.55 11 14 11Z"
                  fill="#424167"
                />
              </svg>
            </button>
            <button className="btn" onClick={() => setexportPopupOpen(true)}>Export
              <svg
                className="svg-blue-dark"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="17"
                viewBox="0 0 14 17"
                fill="none"
              >
                <path
                  d="M11.59 6H10V1C10 0.45 9.55 0 9 0H5C4.45 0 4 0.45 4 1V6H2.41C1.52 6 1.07 7.08 1.7 7.71L6.29 12.3C6.68 12.69 7.31 12.69 7.7 12.3L12.29 7.71C12.92 7.08 12.48 6 11.59 6ZM0 16C0 16.55 0.45 17 1 17H13C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15H1C0.45 15 0 15.45 0 16Z"
                  fill="#424167"
                />
              </svg>
            </button>
            <button className="btn" onClick={AllGroupList}>Refresh
              <svg
                className="svg-blue-dark"
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="21"
                viewBox="0 0 17 21"
                fill="none"
              >
                <path
                  d="M7.99905 3.99857V1.20857C7.99905 0.758566 7.45905 0.538566 7.14905 0.858566L3.34905 4.64857C3.14905 4.84857 3.14905 5.15857 3.34905 5.35857L7.13905 9.14857C7.45905 9.45857 7.99905 9.23857 7.99905 8.78857V5.99857C11.7291 5.99857 14.6791 9.41857 13.8591 13.2886C13.3891 15.5586 11.5491 17.3886 9.28905 17.8586C5.71905 18.6086 2.53905 16.1586 2.05905 12.8486C1.98905 12.3686 1.56905 11.9986 1.07905 11.9986C0.479051 11.9986 -0.000948563 12.5286 0.0790514 13.1286C0.699051 17.5186 4.87905 20.7686 9.60905 19.8486C12.7291 19.2386 15.2391 16.7286 15.8491 13.6086C16.8391 8.47857 12.9391 3.99857 7.99905 3.99857Z"
                  fill="#424167"
                />
              </svg>
            </button>
          </div>
          <div className="userlist_table">
            <Table1
              editTable={false}
              height={"auto"}
              Tablecoloum={groupsColumn1}
              tableRow={data}
              load={load}
              coloumWidthText={"userGroups"}
              mandatoryColoum={"Group Name"}
              exportInDifferentFormate={true}
              exportPopupOpen={exportPopupOpen}
              setexportPopupOpen={setexportPopupOpen}
              exporttitle={"UserGroups"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UserGroups;